module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "CloudChainBusinessLicense");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CloudChainBusinessLicense!./src/pages/Shop/Member/Personal/CloudChain/CloudChainBusinessLicense/index.js
// module id = 1090
// module chunks = 438